import {
  Calendar,
  Phone,
  MapPin,
  Clock,
  Star,
  Award,
  Heart,
  Shield,
  Building2,
  Package,
  Stethoscope,
  PlusCircle,
  Baby,
  Bone,
  Brain,
  Microscope,
  ChevronRight,
  Download,
  CheckCircle,
  Trophy,
  BadgeIcon as Certificate,
  User,
  ArrowRight,
} from "lucide-react"

import { BlogCard } from "../blog-card"
import { Link } from "react-router-dom"
import { Button } from "../ui/button"
import { Badge } from "../ui/badge"



export default function MobileAppPromowidget() {
  return (
          <section className="py-8 bg-primary text-primary-foreground">
                  <div className="container px-4 mx-auto">
                    <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
                      <div className="text-center md:text-left">
                        <h3 className="text-xl font-bold md:text-2xl">Download Our Mobile App</h3>
                        <p className="mt-2">Book appointments, view reports, and manage your health on the go.</p>
                      </div>
                      <div className="flex flex-wrap gap-4">
                        <Button variant="secondary" className="gap-2" asChild>
                          <Link to="/app/ios">
                            <Download className="w-4 h-4" />
                            App Store
                          </Link>
                        </Button>
                        <Button variant="secondary" className="gap-2" asChild>
                          <Link to="/app/android">
                            <Download className="w-4 h-4" />
                            Play Store
                          </Link>
                        </Button>
                      </div>
                    </div>
                  </div>
                </section>
    
  );
}

 